
export default class BaseService {
  httpTool
  constructor (axios) {
    this.httpTool = axios
  }
}
